import React from 'react'
import {
  Button,
  ButtonGroup,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@mui/material'
import DescriptionIcon from '@mui/icons-material/Description'
import { PickingValidateSkuDetail } from '../../interfaces/Picking/Picking'
import { useStyles } from './styles'

interface CustomActionButtonsProps {
  row: PickingValidateSkuDetail
  orderCancellationRequest: boolean
  isPickingRouteGroupedValidation: boolean
  onOpenReportDiff: (row: PickingValidateSkuDetail) => void
  onOpenExcessQty: (row: PickingValidateSkuDetail) => void
  onOpenBatches?: (row: PickingValidateSkuDetail) => void
}

export const CustomActionButtons: React.FC<CustomActionButtonsProps> = ({
  row,
  orderCancellationRequest,
  isPickingRouteGroupedValidation,
  onOpenReportDiff,
  onOpenBatches
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  if (matchesLG) {
    return (
      <ButtonGroup
        orientation='vertical'
        aria-label='vertical outlined primary button group'
      >
        <Button
          className={
            !isPickingRouteGroupedValidation && !row.validated
              ? ''
              : classes.secondary
          }
          onClick={() => onOpenReportDiff(row)}
          disabled={!isPickingRouteGroupedValidation && !row.validated}
        >
          {(orderCancellationRequest && 'DEVOLVER STOCK') || 'DIFERENCIA'}
        </Button>
        {row.batches && row.batches.length > 0 && (
          <Button
            color='primary'
            variant='contained'
            onClick={() => onOpenBatches?.(row)}
          >
            LOTES
          </Button>
        )}
      </ButtonGroup>
    )
  }

  return (
    <ButtonGroup
      orientation='vertical'
      aria-label='vertical outlined primary button group'
    >
      <Tooltip title='Informar Diferencias' aria-label='infoDiferencias'>
        <Button
          disabled={!isPickingRouteGroupedValidation && !row.validated}
          size='small'
          className={`${classes.secondary} ${classes.btnDownload}`}
          startIcon={<DescriptionIcon />}
          onClick={() => onOpenReportDiff(row)}
          variant='contained'
        />
      </Tooltip>

      {row.batches && row.batches.length > 0 && (
        <Tooltip title='Ver Lotes' aria-label='verLotes'>
          <Button
            size='small'
            color='primary'
            variant='contained'
            startIcon={<DescriptionIcon />}
            onClick={() => onOpenBatches?.(row)}
            className={classes.btnDownload}
          />
        </Tooltip>
      )}
    </ButtonGroup>
  )
}
